

export const content = {
  'Collectief systeem': {
    title: 'Warmtenet',
    content: `In dichtbebouwde gebieden, zoals wijken met veel flats, is een warmtenet  waarschijnlijk de meest logische keuze. Er zijn in Veenendaal meerdere duurzame warmtebronnen mogelijk voor het warmtenet. De gemeente gaat de komende jaren onderzoeken welke warmtebronnen hiervoor het beste zijn: duurzaam, betrouwbaar, en tegen de laagste kosten.

De keuze voor een warmtenet in een wijk betekent niet dat alle woningen daar verplicht op worden aangesloten. Voor eigenaren van een goed geïsoleerde woning kan het aantrekkelijker zijn een warmtepomp te nemen. `
  },
  "Individueel/klein-collectief": {
    title: 'Per woning of bouwblok',
    content: `In wijken waar de woningen verder uit elkaar staan, is het vaak te duur om een warmtenet aan te leggen. Hier zijn oplossingen per woning aantrekkelijker. Dit zijn bijvoorbeeld:

* Luchtwarmtepomp
* Bodemwarmtepomp. 
* Warmtepomp met zonnewarmte

Er zullen ook systemen worden gebouwd voor een bouwblok, een rijtje huizen of een appartementengebouw.`
  },
  "Bedrijventerrein": {
    title: 'Bedrijven / kantoren',
    content: `Door de industrie wordt aardgas niet alleen gebruikt om gebouwen te verwarmen, maar ook bij productie. Opslagloodsen hebben meestal juist weinig verwarming. Op de bedrijventerreinen zullen we daarom naar elk bedrijf apart kijken wat er nodig is. Dit doen wij samen met de bedrijvenvereniging.

In De Vendel, De Compagnie en De Compagnie-Oost staan vooral kantoren. Voor kantoren is bodemwarmte vaak geschikt, omdat dit ook koeling geeft. Dit kan per gebouw, of voor een groep gebouwen worden aangelegd. Ook luchtwarmtepompen en luchtkoelers zijn mogelijk. `
  },
  "Bestaand/gepland warmtenet": {
    title: 'Bestaand/gepland warmtenet',
    content: `De nieuwbouw in Veenendaal-Oost heeft al een warmtenet. Ook voor de nog te bouwen delen van de wijk gaat de voorkeur uit naar een warmtenet. Het bestaande warmtenet maakt nu nog (deels) gebruik van aardgas. Er worden nieuwe duurzame warmtebronnen gezocht. Hiervoor zijn geen aanpassingen in de woningen nodig.`
  },
  'Collectief of individueel/klein-collectief': {
    title: 'Warmtenet of per woning / bouwblok',
    content: `In het gestreepte gedeelte is de meest geschikte techniek nog onzeker. In deze wijken is eerst meer onderzoek nodig voordat we weten wat beter is: een warmtenet of oplossingen per woning.`
  }
}


export const screenreader = `

<h3>Warmtenet</h3>
<p>
In dichtbebouwde gebieden, zoals wijken met veel flats, is een <a href="https://www.duurzaamveenendaal.nl/aardgasvrij/1661330.aspx?t=Koken-en-verwarmen-zonder-gas-De-alternatieven/#oplossing_hele_wijk">warmtenet&nbsp;</a>&nbsp;waarschijnlijk de meest logische keuze. Er zijn in Veenendaal meerdere duurzame warmtebronnen mogelijk voor het warmtenet. De gemeente gaat de komende jaren onderzoeken welke warmtebronnen hiervoor het beste zijn: duurzaam, betrouwbaar, en tegen de laagste kosten.
</p>
<p>
De keuze voor een warmtenet in een wijk betekent niet dat alle woningen daar verplicht op worden aangesloten. Voor eigenaren van een goed geïsoleerde woning kan het aantrekkelijker zijn een warmtepomp te nemen.
</p>

<h3>Per woning of bouwblok</h3>
<p>
In wijken waar de woningen verder uit elkaar staan, is het vaak te duur om een warmtenet aan te leggen. Hier zijn <a href="https://www.duurzaamveenendaal.nl/aardgasvrij/1661330.aspx?t=Koken-en-verwarmen-zonder-gas-De-alternatieven/#oplossingen_per_woning">oplossingen per woning</a> aantrekkelijker. Dit zijn bijvoorbeeld:
</p>
<ul>
<li>Luchtwarmtepomp</li>
<li>Bodemwarmtepomp</li>
<li>Warmtepomp met zonnewarmte</li>
</ul>
<p>
Er zullen ook systemen worden gebouwd voor een bouwblok, een rijtje huizen of een appartementengebouw.
</p>

<h3>Warmtenet of per woning</h3>
<p>
In het gestreepte gedeelte is de meest geschikte techniek nog onzeker. In deze wijken is eerst meer onderzoek nodig voordat we weten wat beter is: een warmtenet of oplossingen per woning.
</p>

<h3>Bestaand/gepland warmtenet</h3>
<p>
De nieuwbouw in Veenendaal-Oost heeft al een warmtenet. Ook voor de nog te bouwen delen van de wijk gaat de voorkeur uit naar een warmtenet. Het bestaande warmtenet maakt nu nog (deels) gebruik van aardgas. Er worden nieuwe duurzame warmtebronnen gezocht. Hiervoor zijn geen aanpassingen in de woningen nodig.
</p>

<h3>Kantoren/bedrijven</h3>
<p>
Door de industrie wordt aardgas niet alleen gebruikt om gebouwen te verwarmen, maar ook bij productie. Opslagloodsen hebben meestal juist weinig verwarming. Op de bedrijventerreinen zullen we daarom naar elk bedrijf apart kijken wat er nodig is. Dit doen wij samen met de bedrijvenvereniging.
<br>
In De Vendel, De Compagnie en De Compagnie-Oost staan vooral kantoren. Voor kantoren is bodemwarmte vaak geschikt, omdat dit ook koeling geeft. Dit kan per gebouw, of voor een groep gebouwen worden aangelegd. Ook luchtwarmtepompen en luchtkoelers zijn mogelijk.
</p>`